(function () {
  'use strict';

  angular.module('app').component('tourCostsAndPrices', tourCostsAndPrices());

  function tourCostsAndPrices() {
    return {
      bindings: {
        tour: '<',
        onCostsAndPricesSaved: '&',
        defaultLanguage: '<',
        userLanguageCode: '<',
      },
      controller: TourCostsAndPricesComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/tours/components/tour-costs-and-prices/tour-costs-and-prices.component.html',
    };
  }

  TourCostsAndPricesComponent.$inject = ['zoneService'];

  function TourCostsAndPricesComponent(zoneService) {
    const vm = this;

    vm.$onInit = function () {
      vm.showCosts = true;
      vm.showPrices = true;

      // Initilizers
      getZonesByProduct();
    };

    vm.onSeasonSelected = function (season) {
      vm.seasonSelected = season;
    };

    vm.onProductCostsAndPricesSaved = function (associated_providers) {
      vm.onCostsAndPricesSaved({ associated_providers: associated_providers });
    };

    // Get active zones by product location
    function getZonesByProduct() {
      if (!vm.tour.location_id) {
        vm.zonesByProduct = [];
        return;
      }

      if (vm.zonesByProduct) {
        return;
      }

      let filterCriteria = {
        get: 'by_location',
        location_id: vm.tour.location_id,
        // lang: vm.defaultLanguage,
        lang: vm.userLanguageCode,
        skip_check_role: true,
      };

      zoneService.getZones(filterCriteria).subscribe((response) => {
        vm.zonesByProduct = response;
      });
    }
  }
})();
